import { render } from "./Cellphone.vue?vue&type=template&id=67514780"
import script from "./Cellphone.vue?vue&type=script&lang=js"
export * from "./Cellphone.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Cellphone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67514780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67514780', __exports__)) {
    api.reload('67514780', __exports__)
  }
  
  module.hot.accept("./Cellphone.vue?vue&type=template&id=67514780", () => {
    api.rerender('67514780', render)
  })

}


export default __exports__